const toastification_component = () => import('@core/components/toastification/ToastificationContent.vue');

export const showToast = (vue, title, text, icon) => {
  toastification_component().then((component) => {
    vue.$toast({
      component: component.default,
      props: {
        title,
        icon,
        text,
        variant: 'danger'
      }
    }, {
      position: 'top-center',
      timeout: 5000
    });
  });
  return false;
};

export const getIconWhitePng = (network) => {
  if (network === 'facebook') return require("@/assets/images/icons/facebook_white.png")
  if (network === 'instagram' || network === 'instagram_reels') return  require("@/assets/images/icons/insta_white.png")
  if (network === 'linkedin') return require("@/assets/images/icons/linkedin_white.png")
  if (network === 'twitch') return require("@/assets/images/icons/twitch_white.png")
  if (network === 'twitter') return require("@/assets/images/icons/twitter-x.png")
  if (network === 'youtube') return require("@/assets/images/icons/youtube_white.png")
  if (network === 'youtube_shorts') return require("@/assets/images/icons/yt_shorts.png")
  if (network === 'tiktok') return require("@/assets/images/icons/tiktok_white.png")
  if (network === 'spotify' || network === 'podcast') return require("@/assets/images/icons/spotify_white.png")
  if (network === 'pinterest') return require("@/assets/images/icons/pinterest_white.png")
  if (network === 'blog') return require("@/assets/images/icons/wordpress-icon-white.png")
  if (network === 'snapchat') return require("@/assets/images/icons/snapchat_white.png")
  if (network === 'reddit') return require("@/assets/images/icons/reddit_icon_white.png")
  if (network === 'threads') return require("@/assets/images/icons/threads.png")
}
export const getIconWhite = (network) => {
  if (network === 'facebook') return require("@/assets/images/icons/facebook_white.svg")
  if (network === 'instagram' || network === 'instagram_reels') return  require("@/assets/images/icons/insta_white.svg")
  if (network === 'linkedin') return require("@/assets/images/icons/linkedin_white.svg")
  if (network === 'twitch') return require("@/assets/images/icons/twitch_white.svg")
  if (network === 'twitter') return require("@/assets/images/icons/twitter-x.svg")
  if (network === 'youtube' || network === 'youtube_internal') return require("@/assets/images/icons/youtube_white.svg")
  if (network === 'youtube_shorts') return require("@/assets/images/icons/yt_shorts.svg")
  if (network === 'tiktok') return require("@/assets/images/icons/tiktok_white.svg")
  if (network === 'spotify' || network === 'podcast') return require("@/assets/images/icons/spotify_white.svg")
  if (network === 'pinterest') return require("@/assets/images/icons/pinterest_white.svg")
  if (network === 'blog') return require("@/assets/images/icons/wordpress-icon-white.svg")
  if (network === 'snapchat') return require("@/assets/images/icons/snapchat_white.svg")
  if (network === 'reddit') return require("@/assets/images/icons/reddit_icon_white.svg")
  if (network === 'threads') return require("@/assets/images/svg/threads.svg")
  if (network === 'telegram') return require("@/assets/images/icons/telegram_white.svg")
  if (network === 'whatsapp') return require("@/assets/images/icons/whatsapp_white.svg")
}
export const getColor = (network, black_tiktok = false) => {
  if (network === 'facebook') return '#3b5998'
  if (network === 'instagram') return '#d6249f'
  if (network === 'linkedin') return '#346297'
  if (network === 'twitch') return '#924DF7'
  if (network === 'twitter') return '#0791ce'
  if (network === 'youtube') return '#c4302b'
  if (network === 'tiktok') return black_tiktok ? '#000000' : '#ff0650'
  if (network === 'spotify') return '#64D862'
  if (network === 'pinterest') return '#E73630'
  if (network === 'blog') return '#00749a'
  if (network === 'snapchat') return '#F5D90D'
  if (network === 'telegram') return '#0088CC'
  if (network === 'whatsapp') return '#25D366'
};
export const getColorV2 = (network, color_default = true) => {
  if (network === 'facebook') return '#3b5998'
  if (network === 'instagram') return '#d6249f'
  if (network === 'linkedin') return '#346297'
  if (network === 'twitch') return '#924DF7'
  if (network === 'twitter') return '#0791ce'
  if (network === 'youtube') return '#c4302b'
  if (network === 'tiktok') return '#000000'
  if (network === 'spotify') return '#64D862'
  if (network === 'pinterest') return '#E73630'
  if (network === 'blog') return color_default ? '#FFF' : '#00749a'
  if (network === 'snapchat') return '#F5D90D'
  if (network === 'telegram') return '#0088CC'
  if (network === 'whatsapp') return '#25D366'
};
export const getClassNetworkColor = (network) => {
  
  if (network === 'instagram') return require("@/assets/images/icons/insta_white.svg")
  if (network === 'linkedin') return require("@/assets/images/icons/linkedin_white.svg")
  if (network === 'twitch') return require("@/assets/images/icons/twitch_white.svg")
  if (network === 'twitter') return require("@/assets/images/icons/twitter-x.svg")
  if (network === 'youtube') return require("@/assets/images/icons/youtube_white.svg")
  if (network === 'tiktok') return require("@/assets/images/icons/tiktok_white.svg")
  if (network === 'spotify') return require("@/assets/images/icons/spotify_white.svg")
  if (network === 'pinterest') return require("@/assets/images/icons/pinterest_white.svg")
  if (network === 'blog') return require("@/assets/images/icons/wordpress-icon-white.svg")
  if (network === 'snapchat') return require("@/assets/images/icons/facebook_white.svg")
  if (network === 'facebook') return require("@/assets/images/icons/facebook_white.svg")
};
export const getIconColor = (network, padding_default = true) => {
  if (network === 'facebook') return `${padding_default ? 'padding-07' : 'padding-03'} facebook-border`
  if (network === 'instagram') return `${padding_default ? 'padding-07' : 'padding-03'} instagram-border`
  if (network === 'linkedin') return `${padding_default ? 'padding-07' : 'padding-03'} linkedin-border`
  if (network === 'twitch') return `${padding_default ? 'padding-07' : 'padding-03'} twitch-border`
  if (network === 'twitter') return `${padding_default ? 'padding-07' : 'padding-03'} twitter-border`
  if (network === 'youtube' || network === 'youtube_internal') return `${padding_default ? 'padding-07' : 'padding-03'} youtube-border`
  if (network === 'tiktok') return `${padding_default ? 'padding-07' : 'padding-03'} tiktok-border`
  if (network === 'spotify') return 'spotify-border padding-03'
  if (network === 'pinterest') return `${padding_default ? 'padding-07' : 'padding-03'} pinterest-border`
  if (network === 'blog') return 'word-press-border'
  if (network === 'snapchat') return `${padding_default ? 'padding-07' : 'padding-03'} snapchat-border`
  if (network === 'threads') return `${padding_default ? 'padding-07' : 'padding-03'} tiktok-border`
  if (network === 'telegram') return `${padding_default ? 'padding-07' : 'padding-03'} telegram-border`
  if (network === 'whatsapp') return `${padding_default ? 'padding-07' : 'padding-03'} whatsapp-border`
};
export const getClassNetworkSpan = (network) => {
  if (network === 'facebook') return 'icomoon-Facebook-2 facebook'
  if (network === 'instagram') return 'icomoon-instagram1 instagram'
  if (network === 'linkedin') return 'icomoon-Linkedin linkedin'
  if (network === 'twitch') return 'iconNetwork-twitch twitch'
  if (network === 'twitter') return require("@/assets/images/icons/twitter-x-black.svg")
  if (network === 'youtube') return 'icomoon-youtube youtube'
  if (network === 'tiktok') return 'icomoon-tiktok tiktok'
  if (network === 'spotify') return 'iconNetwork-spotify spotify'
  if (network === 'pinterest') return 'icomoon-pinterest2 pinterest'
  if (network === 'blog') return 'iconNetwork-blogger blog'
  if (network === 'snapchat') return 'iconNetwork-snapchat-ghost snapchat'
};

export const getLocalNetworkName = (network) => {
  if (network === 'facebook') return 'facebook'
  if (network === 'ig') return 'instagram'
  if (network === 'instagram') return 'instagram'
  if (network === 'linkedin') return 'linkedin'
  if (network === 'twitch') return 'twitch'
  if (network === 'twitter') return 'twitter'
  if (network === 'yt') return 'youtube'
  if (network === 'youtube') return 'youtube'
  if (network === 'tt') return 'tiktok'
  if (network === 'tiktok') return 'tiktok'
  if (network === 'spotify') return 'spotify'
  if (network === 'pinterest') return 'pinterest'
  if (network === 'blog') return 'blog'
  if (network === 'snapchat') return 'snapchat'
  if (network === 'tr') return 'twitter'
  if (network === 'tw') return 'twitch'
};

export const getContent = (type) => {
  if (type === 'photo') return 'camera'
  if (type === 'video') return 'camera-video'
  if (type === 'story') return 'clock-history'
  if (type === 'streaming') return 'display'
  if (type === 'instagram_tv') return 'instagram'
  if (type === 'reel') return 'camera-reels'
  if (type === 'post') return 'images'
  if (type === 'snap') return 'file-earmark-play' 
  if (type === 'podcast') return 'soundwave'
  if (type === 'clip') return 'joystick'
  return 'award'
};
export const getDropdownNetworks = () => {
  return  [
    {
      value: "tiktok",
      network: "TikTok",
      icon: require("@/assets/images/icons/tiktok_white.svg"),
    },
    {
      value: "spotify",
      network: "Spotify",
      icon: require("@/assets/images/icons/spotify_white.svg"),
    },
    {
      value: "snapchat",
      network: "Snapchat",
      icon: require("@/assets/images/icons/snapchat_white.svg"),
    },
    {
      value: "blog",
      network: "Blog",
      icon: require("@/assets/images/icons/wordpress-icon-white.svg"),
    },
    {
      value: "pinterest",
      network: "Pinterest",
      icon: require("@/assets/images/icons/pinterest_white.svg"),
    },

    {
      value: "linkedin",
      network: "LinkedIn",
      icon: require("@/assets/images/icons/linkedin_white.svg"),
    },
    {
      value: "youtube",
      network: "Youtube",
      icon: require("@/assets/images/icons/youtube_white.svg"),
    },
    {
      value: "instagram",
      network: "Instagram",
      icon: require("@/assets/images/icons/insta_white.svg"),
    },
    {
      value: "twitter",
      network: "Twitter",
      icon: require("@/assets/images/icons/twitter-x.svg"),
    },
    {
      value: "twitch",
      network: "Twitch",
      icon: require("@/assets/images/icons/twitch_white.svg"),
    },
    {
      value: "facebook",
      network: "Facebook",
      icon: require("@/assets/images/icons/facebook_white.svg"),
    },
    {
      value: "telegram",
      network: "Telegram",
      icon: require("@/assets/images/icons/telegram_white.svg"),
    },
    {
      value: "whatsapp",
      network: "WhatsApp",
      icon: require("@/assets/images/icons/whatsapp_white.svg"),
    },
  ]
};
export const getImageNetwork = (network) => {
  if (network === 'facebook') return require('@/assets/images/anlytics/facebook.png')
  if (network === 'instagram') return require('@/assets/images/anlytics/instagram.png')
  if (network === 'linkedin') return require('@/assets/images/anlytics/linkedin.png')
  if (network === 'twitch') return require('@/assets/images/anlytics/twitch.png')
  if (network === 'twitter') return require('@/assets/images/icons/twitter-x-black.svg')
  if (network === 'youtube') return require('@/assets/images/anlytics/youtube.png')
  if (network === 'tiktok') return require('@/assets/images/anlytics/tiktok.png')
  if (network === 'spotify') return require('@/assets/images/anlytics/spotify.png')
  if (network === 'pinterest') return require('@/assets/images/anlytics/pinterest.png')
  if (network === 'blog') return require('@/assets/images/icons/wordpress-icon.svg')
  if (network === 'snapchat') return require('@/assets/images/anlytics/snapchat.png')
};
export const getImageNetworkColor = (network, x_twitter = true) => {
  if (network === 'facebook') return require("@/assets/images/icons/facebook2.svg")
  if (network === 'instagram') return require("@/assets/images/icons/instagram2.svg")
  if (network === 'linkedin') return require("@/assets/images/icons/linkedin2.svg")
  if (network === 'twitch') return require("@/assets/images/icons/twitch2.svg")
  if (network === 'twitter') return `${x_twitter ? require("@/assets/images/icons/twitter-x.svg") : require("@/assets/images/icons/twitter-x-circle.svg")}` 
  if (network === 'youtube') return require("@/assets/images/icons/youtube2.svg")
  if (network === 'tiktok') return require("@/assets/images/icons/tiktok2.svg")
  if (network === 'spotify') return require("@/assets/images/icons/spotify2.svg")
  if (network === 'pinterest') return require("@/assets/images/icons/pinterest2.svg")
  if (network === 'blog') return require("@/assets/images/icons/wordpress-icon.svg")
  if (network === 'snapchat') return require("@/assets/images/icons/snapchat2.svg")
};

const INTEREST_ICONS = {
  'NFT': 'nft',
  'Gaming': 'gaming',
  'Video Gaming': 'gaming',
  'Crypto': 'crypto',
  'Politics': 'politics',
  'Business & Careers': 'business',
  'Modeling': 'modeling',
  'Fashion': 'fashion',
  'Nature & landscapes': 'nature',
  'Travel': 'travel',
  'Photography': 'photography',
  'Fitness & Gym': 'fitness',
  'Trainers & Coaches': 'coach',
  'Cinema & Actors/actresses': 'cinema',
  'Management & Marketing': 'marketing',
  'Beauty': 'beauty',
  'Lifestyle': 'lifestyle',
  'Music': 'music',
  'Family': 'family',
  'Finance & Economics': 'finance',
  'Art/Artists': 'art',
  'Literature & Journalism': 'literature',
  'Literature': 'literature',
  'Sports with a ball': 'sport_ball',
  'Kids & Toys': 'kids',
  'Shows': 'shows',
  'Humor & Fun & Happiness': 'humor',
  'Winter sports': 'sport_winter',
  'Adult content': 'adult_content',
  'Tobacco & Smoking': 'tabaco',
  'Alcohol': 'alcohol',
  'Extreme Sports & Outdoor activity': 'sport_xtreme',
  'Machinery & Technologies': 'machine',
  'Luxury': 'luxury',
  'Computers & Gadgets': 'computer',
  'Clothing & Outfits': 'outfits',
  'Mobile related': 'mobile',
  'Science': 'science',
  'Racing Sports': 'racing',
  'Cars & Motorbikes': 'bikers',
  'Food & Cooking': 'food',
  'Architecture & Urban Design': 'architecture',
  'Animals': 'animals',
  'Comics & sketches': 'comics',
  'Health & Medicine': 'salud',
  'Shopping & Retail': 'shopping',
  'Accessories & Jewellery': 'jewellery',
  'Water sports': 'sport_water',
  'DIY & Design': 'diy',
  'Sweets & Bakery': 'bakery',
  'Education': 'education',
  'Educational': 'education',
  'Volleyball': 'Volleyball',
  'Football & Soccer': 'soccer',
  'Baseball': 'baseball',
  'American Football': 'american',
  'Basketball': 'basketball',
  'Social Issues': 'social',
  'Film & Television': 'television',
  'Entertainment': 'entertainment',
  'Business and Careers': 'careers',
  'Ice Hockey': 'hockey',
  'Theater': 'theater',
  'Dance': 'dance',
  'Traveling': 'traveling',
  'Unboxings': 'unboxing',
  'Parenting & Relationships': 'parenting',
  'Stand-up Comedy': 'comedy',
  'Finance & Accounting': 'accounting',
  'Running & Athletics': 'running',
  'Fitness & Bodybuilding': 'fit',
  'Tennis': 'tennis',
  'Skincare': 'skincare',
  'Yoga': 'yoga',
  'Technology & Gadgets': 'gadgets',
  'Dining & Nightlife': 'dining',
  'Makeup': 'makeup',
  'Nail Care': 'nailcare',
  'Haircare': 'haircare',
  'Hiking & Trekking': 'hiking',
  "Children's Games & Toys": 'toys',
  'Gastronomy': 'gastronomy',
  'Coffee Culture': 'coffe',
  'Nutritious Foods': 'nutritious',
  'Cooking': 'cooking',
  'Philanthropy & Charity': 'philanthropy',
  'Wrestling': 'wrestling',
  'Religion': 'religion',
  'Snowboarding': 'snowboarding',
  'Ecology': 'ecology',
  'Surfing': 'surfing',
  'Outdoor Camping': 'camping',
  'Skateboarding': 'skateboarding',
  'Motorsports': 'motorsports',
  'Space Exploration': 'exploration',
  'Motorcycles': 'motorcycles',
  'Yachting & Sailing': 'yachting',
  'Space & Astronomy': 'astronomy',
  'Automobiles': 'automobiles',
  'Cosplay': 'Cosplay',
  'Physics': 'physics',
  'Boxing': 'boxing',
  'Handicrafts': 'handicrafts',
  'Architecture & Design': 'design',
  'DIY Projects': 'projects',
  'Property & Real Estate': 'property',
  'Interior Design': 'interiorDesign',
  'Anime, Manga & Comics': 'anime',
  'Sustainability': 'sustainability',
  'Grilling & BBQ': 'bbq',
  'AI & Machine Learning': 'ia',
  'Meditative Practices': 'meditative',
  'Tea': 'tea',
  'History': 'history',
  'Beers': 'beers',
  'Biology': 'biology',
};

export const getIconInterest = (item) => {
  const icon = INTEREST_ICONS[item];
  if (icon) return require(`@/assets/images/Audience-interests/${icon}.svg`);
  return null;
};
export const IconTypeCompetationGreen = (type) => {
  if (type === 'gift_card') return require("@/assets/images/svg/compentation_gift_green.svg")
  if (type === 'service') return require("@/assets/images/svg/compentation_service_green.svg")
  if (type === 'experience') return require("@/assets/images/svg/compentation_experience_green.svg")
};
export const IconTypeCompetation = (type) => {
  if (type === 'gift_card') return require("@/assets/images/svg/compentation_gift.svg")
  if (type === 'service') return require("@/assets/images/svg/compentation_service.svg")
  if (type === 'experience') return require("@/assets/images/svg/compentation_experience.svg")
};
export const IconTypeCompetationPrimary = (type) => {
  if (type === 'gift_card') return require("@/assets/images/svg/compentation_gift_primary.svg")
  if (type === 'service') return require("@/assets/images/svg/compentation_service_primary.svg")
  if (type === 'experience') return require("@/assets/images/svg/compentation_experience_primary.svg")
};
export const getColorPlan = (display_name) => {
  const plan_min = display_name.toLowerCase();

  if (plan_min === 'pro') return 'badge-plan-pro';
  if (plan_min === 'ia') return 'badge-plan-ia';
  if (plan_min === 'ia +') return 'badge-plan-ia_plus';


  if (display_name === 'Creador Pro') return 'badge-plan-pro';
  if (display_name === 'Creador Pro IA') return 'badge-plan-ia';
  if (display_name === 'Creador Pro IA+') return 'badge-plan-ia_plus';
};
export const getBadgeNetwork = (network) => {
  if (network === 'facebook') return 'fb-badge'
  if (network === 'instagram' || network === 'instagram_reels') return 'insta-badge'
  if (network === 'linkedin') return 'lkn-badge'
  if (network === 'twitch') return 'twch-badge'
  if (network === 'twitter') return 'twr-badge'
  if (network === 'youtube' || network === 'youtube_shorts') return 'yt-badge'
  if (network === 'tiktok') return 'tk-badge'
  if (network === 'spotify' || network === 'podcast') return 'spoti-badge'
  if (network === 'pinterest') return 'pinterest-badge'
  if (network === 'blog') return 'blog-badge'
  if (network === 'snapchat') return 'snap-badge'
  if (network === 'reddit') return 'reddit-badge'
  if (network === 'telegram') return 'telegram-badge'
  if (network === 'whatsapp') return 'whatsapp-badge'
};
export const getIconInteractions = (name) => {
  if (name === 'number_of_likes') return 'heart-fill'
  if (name === 'number_of_comments') return 'chat'
  if (name === 'number_of_shares') return 'box-arrow-up-right'
  if (name === 'number_of_rts') return 'box-arrow-up'
  if (name === 'number_of_times_saved') return 'bookmark'
  if (name === 'number_of_times_favs') return 'bookmark'
  if (name === 'number_of_reproductions') return 'play-circle'
  if (name === 'number_of_views') return 'eye'
  if (name === 'number_of_clicks_to_stickers') return 'cursor'
  if (name === 'number_of_clicks_to_the_link') return 'link-45deg'
  if (name === 'number_of_dislikes') return 'hand-thumbs-down'
  if (name === 'number_of_impressions') return 'graph-up'
  if (name === 'number_of_prints') return 'printer'
  if (name === 'number_of_responses') return 'question-circle'
  if (name === 'scope_number') return 'people'
  if (name === 'number_of_interactions') return 'bar-chart-line'
};
export const getIconCategories = (category, network) => {
  if (network === 'instagram') {
    if (category.id  === 1007) return 'bag'
    if (category.id  === 1022) return 'plus-square'
    if (category.id  === 1047) return 'truck'
    if (category.id  === 1009) return 'geo-alt-fill'
    if (category.id  === 1039) return 'camera-reels-fill'
    if (category.id  === 1021) return 'star-fill'
    if (category.id  === 1025) return 'image-alt'
    if (category.id  === 1038) return 'camera-fill'
    if (category.id  === 1023) return 'bicycle'
    if (category.id  === 1031) return 'bicycle'
    if (category.id  === 1032) return 'film'
    if (category.id  === 1044) return 'globe'
    if (category.id  === 1020) return 'flower1'
    if (category.id  === 1041) return 'emoji-sunglasses'
    if (category.id  === 1027) return 'music-note-beamed'
    if (category.id  === 1042) return 'house-door'
    if (category.id  === 1006) return 'graph-up'
    if (category.id  === 1002) return 'brush'
    if (category.id  === 1004) return 'book-fill'
    if (category.id  === 1013) return 'circle'
    if (category.id  === 1046) return 'puzzle-fill'      
    if (category.id  === 1017) return 'calendar-day'
    if (category.id  === 1036) return 'emoji-laughing'
    if (category.id  === 1012) return 'asterisk'
    if (category.id  === 1048) return 'x'
    if (category.id  === 1001) return 'cup-straw'
    if (category.id  === 1014) return 'cloud'
    if (category.id  === 1030) return 'cpu-fill'
    if (category.id  === 1043) return 'gem'
    if (category.id  === 1034) return 'laptop'
    if (category.id  === 1010) return 'music-player'     
    if (category.id  === 1015) return 'trophy-fill'
    if (category.id  === 1018) return 'stoplights'
    if (category.id  === 1035) return 'egg-fried'
    if (category.id  === 1003) return 'bricks'
    if (category.id  === 1026) return 'bug-fill'
    if (category.id  === 1016) return 'book-half'
    if (category.id  === 1028) return 'shop'
    if (category.id  === 1000) return 'watch'
    if (category.id  === 1011) return 'droplet-fill'
    if (category.id  === 1037) return 'building'
    if (category.id  === 1019) return 'heart'  
    if (category.id  === 1033) return 'award'
    if (category.id  === 6) return 'brightness-alt-high'
    if (category.id  === 8) return 'dice5'  
    if (category.id  === 23) return 'display'
    if (category.id  === 33) return 'flower2'
    if (category.id  === 37) return 'hand-thumbs-up'  
    if (category.id  === 11) return 'tree'
    if (category.id  === 1029) return 'eyeglasses'
    if (category.id  === 14) return 'bug-fill'  
    if (category.id  === 28) return 'cup-straw' 
    if (category.id  === 17) return 'bicycle'  
    if (category.id  === 1005) return 'briefcase'
  } else if (network === 'youtube') {
    if (category.id  === 2) return 'pencil'
    if (category.id  === 1) return 'bug-fill'
    if (category.id  === 12) return 'bicycle'
    if (category.id  === 4) return 'stoplights'
    if (category.id  === 5) return 'flower1'
    if (category.id  === 6) return 'menu-button-wide-fill'
    if (category.id  === 21) return 'cpu-fill'
    if (category.id  === 13) return 'egg-fried'
    if (category.id  === 22) return 'trophy'
    if (category.id  === 7) return 'brush'
    if (category.id  === 9) return 'award'
    if (category.id  === 10) return 'house-door'
    if (category.id  === 15) return 'emoji-laughing'
    if (category.id  === 8) return 'search'
    if (category.id  === 23) return 'puzzle-fill'
    if (category.id  === 18) return 'patch-question'
    if (category.id  === 11) return 'camera-reels-fill'
    if (category.id  === 17) return 'music-note-beamed'
    if (category.id  === 19) return 'card-heading'
    if (category.id  === 16) return 'film'
    if (category.id  === 14) return 'plus-square'
    if (category.id  === 20) return 'calendar-day'
    if (category.id  === 3) return 'soundwave'
    if (category.id  === 24) return 'geo-alt-fill'
  } else if (network === 'tiktok') {
    if (category.id  === 19) return 'cloud'
    if (category.id  === 17) return 'heart'
    if (category.id  === 1) return 'bug-fill'
    if (category.id  === 12) return 'bicycle'
    if (category.id  === 3) return 'brush'
    if (category.id  === 4) return 'stoplights'
    if (category.id  === 9) return 'music-note-beamed'
    if (category.id  === 13) return 'cup-straw'
    if (category.id  === 5) return 'flower1'
    if (category.id  === 24) return 'award'
    if (category.id  === 6) return 'emoji-laughing'
    if (category.id  === 25) return 'trophy'
    if (category.id  === 10) return 'house-door'
    if (category.id  === 16) return 'tree'
    if (category.id  === 7) return 'search'
    if (category.id  === 14) return 'dice5'
    if (category.id  === 11) return 'camera-reels-fill'
    if (category.id  === 15) return 'plus-square'
    if (category.id  === 26) return 'geo-alt-fill'
    if (category.id  === 8) return 'stopwatch'
  }
};

export const getCategoryIconSearcher = (category) => {
  const icons = {
    Fashion: 'bag',
    'Food & Beverages': 'cup-straw',
    Beauty: 'brush',
    Modelling: 'camera',
    Travel: 'geo-alt',
    Sports: 'trophy',
    Pets: 'heart-fill',
    'Wildlife & Nature': 'tree',
    Science: 'lightbulb',
    Industry: 'gear',
    'Outdoor Activities': 'signpost-2',
    Vehicles: 'truck',
    Hobbies: 'controller',
    'Handmade & DIY': 'tools',
    'Family & Parenting': 'house',
    Kids: 'emoji-smile',
    'Social Organisations': 'people',
    Entertainment: 'film',
    Music: 'music-note-beamed',
    'Religion & Spirituality': 'star',
    Politics: 'flag',
    Tech: 'cpu',
    History: 'clock-history',
    'Gym & Fitness': 'lightning',
    'Health & Medicine': 'heart-pulse',
    Business: 'briefcase',
    Art: 'palette',
    Cinema: 'camera-reels',
    Beer: 'cup',
    Makeup: 'brush',
    Supermodels: 'star-fill',
    'Football & Soccer': 'trophy',
    Dogs: 'heart-fill',
    Wildlife: 'tree-fill',
    Ecology: 'flower1',
    'Agriculture & Farming': 'flower2',
    'Outdoor Lifestyle': 'sun',
    Cars: 'truck',
    Crafts: 'scissors',
    Motherhood: 'emoji-heart-eyes',
    'Toys & Games': 'controller',
    'LGBTQ+': 'rainbow',
    Anime: 'film',
    'Math & Engineering Education': 'calculator',
    'Alternative Medicine': 'heart',
    'Street Fashion': 'bag',
    'Fine Arts': 'palette2',
    'Cultural Studies': 'book',
    'Performance Arts': 'music-note-list',
    'Spiritual Healing': 'stars',
    'Historical Figures': 'clock-history',
    'Sports Equipment': 'trophy',
    'Travel Accessories': 'geo-alt',
    'Luxury Goods': 'gem',
    'Lifestyle & Wellness': 'flower1',
    Gardening: 'flower2',
    'Home Improvement': 'tools',
    'Pet Care': 'heart-fill',
    'Eco-Friendly Products': 'recycle',
    'Seasonal Trends': 'brightness-high',
    'Fitness Equipment': 'lightning',
    'Culinary Arts': 'egg-fried',
    Beverages: 'cup-straw',
    'Digital Art': 'brush',
    Collectibles: 'box',
    'Fitness Classes': 'lightning',
    'Music Genres': 'music-note-beamed',
    'Home Decor': 'lamp',
    'Outdoor Gear': 'sun',
    'Special Events': 'calendar-event',
    'Health Products': 'heart-pulse',
    'Travel Destinations': 'geo-alt',
    'Technology Trends': 'cpu',
    Workshops: 'tools',
    'Fashion Trends': 'bag',
    'Gaming Accessories': 'controller',
    'Mental Health': 'emoji-smile',
    'Beauty Products': 'brush',
    'Cooking Equipment': 'egg-fried',
    'Social Media': 'share',
    Photography: 'camera',
    'Handmade Crafts': 'scissors',
    'Fitness Programs': 'lightning',
    'Camping Gear': 'signpost-2',
    'Educational Resources': 'book',
    'Personal Care': 'heart',
    'Travel Services': 'geo-alt',
    'Arts & Crafts': 'palette',
    'Health & Fitness': 'heart-pulse',
    'Lifestyle Products': 'bag',
    'Travel Gadgets': 'geo-alt',
    'Fashion Accessories': 'bag',
    'Cultural Events': 'calendar-event',
    Charity: 'heart',
    'Gaming Events': 'controller',
    'Decorative Arts': 'palette',
    'Unique Finds': 'box',
    'Art Supplies': 'brush',
    'Entertainment Venues': 'building',
    'Music Events': 'music-note-beamed',
    'Technology Products': 'cpu',
    'Crafts Supplies': 'tools',
    'Spiritual Products': 'stars',
    'Travel Gear': 'geo-alt',
    'Fitness Accessories': 'lightning',
    'Photography Gear': 'camera',
    'Historical Artifacts': 'clock-history',
    'Artistic Events': 'palette',
    'Collectibles & Memorabilia': 'box',
    'Adventure Gear': 'compass',
    'Health Services': 'heart-pulse',
    'Fashion Events': 'bag',
    'Craft Events': 'scissors',
    'Music Gear': 'music-note-beamed',
    'Beauty Trends': 'brush',
    'Educational Events': 'book',
    'Gaming Platforms': 'controller',
    'Travel Experiences': 'geo-alt',
    'Creative Workshops': 'brush',
    'Sports Events': 'trophy',
    'Fitness Trends': 'lightning',
    'Technology Events': 'cpu',
    'Wellness Products': 'heart',
    'Fashion Items': 'bag',
    'Art Exhibitions': 'palette',
    'Social Media Trends': 'share',
    'Educational Materials': 'book',
    'Gaming Experiences': 'controller',
    'Travel Adventures': 'compass',
    'Beauty Services': 'brush',
    'Music Festivals': 'music-note-list',
    'Crafting Workshops': 'tools',
    'Health Innovations': 'heart-pulse',
    'Fashion Shows': 'bag',
    'Technology Innovations': 'cpu',
    'Lifestyle Events': 'calendar-event',
    'Artistic Trends': 'palette',
    'Travel Ideas': 'geo-alt',
    'Music Innovations': 'music-note-beamed',
    'Crafts and Hobbies': 'scissors',
    'Health and Wellness': 'heart-pulse',
    'Fashion Inspirations': 'bag',
    'Creative Arts': 'palette',
    'Photography Events': 'camera',
    'Gaming Innovations': 'controller',
    'Travel Solutions': 'geo-alt',
    'Beauty Health': 'brush',
    Sculpture: 'box',
    Movies: 'camera-reels',
    Cooking: 'egg-fried',
    Nails: 'brush',
    'Cultural & Historical Travel': 'globe',
    Volleyball: 'trophy',
    Fish: 'water',
    'Marine Life': 'water',
    'Natural Disasters': 'exclamation-triangle',
    'Home Renovation': 'house',
    'Rock Climbing': 'arrow-up-circle',
    Airplanes: 'airplane',
    Sewing: 'scissors',
    'Baby Fashion': 'emoji-smile',
    'Kids Books': 'book',
    'Nonprofit Organizations': 'people',
    'Art & Design': 'palette',
    'Political Leaders': 'mic',
    Drones: 'airplane',
    Yoga: 'flower1',
    'Women Health': 'heart',
    'Leadership & Motivation': 'lightbulb',
    'Outdoor Wear': 'bag',
    Baking: 'egg-fried',
    'Beauty Tips & Hacks': 'brush',
    'Shopping & Fashion Travel': 'bag',
    'American Football': 'trophy',
    'Exotic Pets': 'heart-fill',
    Forests: 'tree-fill',
    'Space Exploration': 'globe2',
    Weapon: 'shield',
    'Trail Running': 'signpost-2',
    Bicycles: 'bicycle',
    Decoration: 'palette2',
    'Child Health': 'emoji-smile',
    'Kids Sports': 'trophy',
    'Professional Associations': 'briefcase',
    'Magic & Illusions': 'stars',
    'Financial Education': 'cash',
    'Politic Shows': 'tv',
    'Gaming Consoles': 'controller',
    Weightlifting: 'lightning',
    'Men Health': 'heart',
    'Sales & Marketing': 'graph-up',
    'Pop Art': 'palette',
    'Children Wear': 'emoji-smile',
    'Healthy Food': 'egg-fried',
    Fragrance: 'droplet',
    'Travel Agencies': 'airplane',
    Rugby: 'trophy',
    'Pet Accessories': 'heart-fill',
    Mountains: 'triangle',
    Technology: 'cpu',
    Gambling: 'dice-5',
    'Mountain Biking': 'bicycle',
    'Electric Cars': 'lightning-charge',
    Friendship: 'people',
    'Social Clubs': 'people-fill',
    'Movies & TV Shows': 'tv',
    'Social Studies Education': 'book',
    Church: 'building',
    'Smart Home': 'house-fill',
    'Personal Development': 'lightbulb',
    Swimwear: 'water',
    'Vegan Food': 'flower1',
    'Beauty Tutorials': 'play-circle',
    Relocation: 'geo-alt',
    Hockey: 'trophy',
    'Pet Training': 'heart-fill',
    'National Parks': 'tree-fill',
    Robotics: 'cpu-fill',
    Casino: 'dice-5',
    Kayaking: 'water',
    'Luxury Cars': 'truck',
    'Home DIY': 'tools',
    'Romantic Relationships & Dating': 'heart-fill',
    Gaming: 'controller',
    'Medical Education': 'book',
    Pastor: 'building',
    Headphones: 'headphones',
    'Sleep Health': 'moon',
    'Green Business': 'flower1',
    'Tattoo Art': 'pen',
    Desserts: 'egg-fried',
    'Organic Beauty': 'flower1',
    'Pet Nutrition': 'heart-fill',
    'Underwater Photography': 'camera',
    Biology: 'lightbulb',
    Surfing: 'water',
    Painting: 'palette',
    Wedding: 'suit-heart',
    Dance: 'music-note-list',
    'Online Education': 'laptop',
    'Tarot Cards': 'stars',
    'Personal Computers': 'pc-display',
    'Addiction & Recovery': 'heart-pulse',
    Startups: 'lightning',
    Shoes: 'bag',
    Coffee: 'cup-hot',
    Barbershops: 'scissors',
    Hotels: 'building',
    Wrestling: 'trophy',
    'Pet Health': 'heart-fill',
    Paddleboarding: 'water',
    Calligraphy: 'pen',
    'Love & Intimacy': 'heart-fill',
    Theater: 'music-note-list',
    Meditation: 'flower1',
    Calisthenics: 'lightning',
    Dentistry: 'emoji-smile',
    Consulting: 'briefcase',
    Accessories: 'gem',
    Wine: 'cup',
    'Self-Care': 'flower1',
    Luxury: 'gem',
    Physics: 'lightbulb',
    'Wildlife Photography': 'camera',
    Pottery: 'box',
    'Sex & Sexuality': 'heart-fill',
    'Music Tour': 'music-note-beamed',
    'Rune Stones': 'stars',
    '3D Printing': 'printer',
    'Cardio Training': 'heart-pulse',
    Medicine: 'heart-pulse',
    Jewelery: 'gem',
    'Meat & Barbecue': 'egg-fried',
    'Climate Change': 'thermometer',
    Sailing: 'water',
    Knitting: 'scissors',
    'Newborn Care': 'emoji-smile',
    Electronic: 'plug',
    'Magical Crystals': 'stars',
    'Software Development': 'code-slash',
    Powerlifting: 'lightning',
    'Eye Health': 'eye',
    'Organic Food': 'flower1',
    Chemistry: 'lightbulb',
    Skydiving: 'arrow-down-circle',
    'Jewellery Making': 'gem',
    'Toddler Activities': 'emoji-smile',
    Standup: 'mic',
    Astrology: 'stars',
    'Tech Reviews': 'cpu',
    Stretching: 'lightning',
    'Hair Health': 'scissors',
    'Health Issues': 'heart-pulse',
    Watches: 'watch',
    Food: 'egg-fried',
    Chess: 'grid-3x3',
    Nanotechnology: 'cpu',
    'Candle Making': 'brightness-high',
    'Single Parenting': 'house',
    Cycling: 'bicycle',
    Psychology: 'emoji-smile',
    'Men\'s Suites': 'bag',
    Running: 'signpost-2',
    'Soap Making': 'droplet',
    'Blended Families': 'people',
    'Parody & Sketches': 'emoji-laughing',
    'Religious Organizations': 'building',
    'Artificial Intelligence': 'cpu-fill',
    'Martial Arts': 'shield',
    Handbags: 'bag-fill',
    Alcohol: 'cup',
    Wwimming: 'water',
    Neuroscience: 'lightbulb',
    'Ceramic Art': 'box',
    Memes: 'emoji-laughing',
    Shamanism: 'stars',
    'Functional Training': 'lightning',
    Streetwear: 'bag',
    Smoothies: 'cup-straw',
    Skateboarding: 'signpost-2',
    Leatherworking: 'scissors',
    'Funny Videos': 'play-circle',
    Activewear: 'bag',
    'Gluten-free Food': 'egg-fried',
    Snowboarding: 'snow',
    'Medical Research': 'search',
    Collage: 'images',
    Boxing: 'shield',
    'Women\'s Fashion': 'bag',
    Golf: 'trophy',
    Geology: 'globe',
    'Vintage Fashion': 'bag',
    Tea: 'cup-hot',
    'Solar Power': 'brightness-high',
    Workwear: 'bag',
    Cocktails: 'cup',
    Handball: 'trophy',
    'Nuclear Power': 'lightning-charge',
    'Kids Fashion': 'emoji-smile',
    'Healthy Eating': 'egg-fried',
    Cricket: 'trophy',
    'Formal Wear': 'bag',
    'Food Reviews': 'star',
    Gymnastics: 'trophy',
    Tennis: 'trophy',
    'Maternity Fashion': 'emoji-heart-eyes',
    'Men\'s Fashion': 'bag',
    'Rock Music': 'music-note-beamed',
    'Rap Music': 'mic',
    'Hiphop Music': 'mic',
    'Classic Music': 'music-note-list',
    'Blues Music': 'music-note-beamed',
    'Alternative Music': 'headphones',
    'Punk Music': 'music-note-beamed',
    'Pop Music': 'music-note-beamed',
    'R&B Music': 'mic',
    'Country Music': 'music-note-beamed',
    'Jazz Music': 'music-note-list',
    'Indie Music': 'headphones',
    'Folk Music': 'music-note-beamed',
    'Reggae Music': 'music-note-beamed',
    'Metal Music': 'music-note-beamed',
    Crossfit: 'lightning',
    Numerology: 'hash',
    Prank: 'emoji-laughing',
    TRX: 'lightning',
    Unboxing: 'box',
    // Categorías adicionales
    Education: 'book',
    Gogs: 'heart-fill',
    Christianity: 'building',
    Smartphones: 'phone',
    Nutrition: 'egg-fried',
    'Real Estate': 'house',
    Architecture: 'building',
    'Actors or Actress': 'camera-reels',
    'TV Show': 'tv',
    'Luxury Fashion': 'gem',
    'Restaurants & Bars': 'cup-straw',
    Skincare: 'brush',
    Cosplay: 'person',
    'Hiking & Trekking': 'signpost-2',
    Basketball: 'trophy',
    Cats: 'heart-fill',
    'Beautiful Nature': 'tree-fill',
    'Astronomy & Space': 'globe2',
    'Furniture Stores': 'lamp',
    Fishing: 'water',
    Motorbikes: 'bicycle',
    Woodworking: 'tools',
    'Baby Food & Nutrition': 'emoji-smile',
    'Kids Education': 'book',
    Comics: 'book-half',
    'Language Learning': 'chat-dots',
    Government: 'flag',
    'VR Devices': 'headset-vr',
    Bodybuilding: 'lightning',
    Entrepreneurship: 'graph-up',
    'Street Art': 'palette',
    Singer: 'mic',
    'TV Series': 'tv',
    Recipes: 'egg-fried',
    Haircare: 'scissors',
    'Adult Modelling': 'camera',
    Camping: 'signpost-2',
    Baseball: 'trophy',
    Birds: 'tree',
    Birdwatching: 'binoculars',
    'Weather & Climate': 'cloud',
    'Vintage & Antique': 'clock-history',
    Hunting: 'crosshair',
    Boats: 'water',
    'Parenting Hacks & Tips': 'lightbulb',
    'Kids Food': 'emoji-smile',
    'Global Warming': 'thermometer',
    Books: 'book',
    Career: 'briefcase',
    'Social Issues': 'people',
    'Internet of Things': 'wifi',
    'Gym Good': 'lightning',
    "Women's Health": 'heart',
    'Political Shows': 'tv',
    "Men's Health": 'heart',
    'Lingerie & Intimates': 'heart-fill',
    Electronics: 'plug',
    'Adult Videos & Pornography': 'film',
    'Ice Skating': 'snow',
  };

  return icons[category] || 'grid';
}